import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
export default {
  /**
   * Returns all projects the user has access to.
   */
  getAll(options = {}) {
    return raw.getAll(routes.projects.all(), {
      include_workspaces: options.includeWorkspaces,
      extra_fields: options.extraFields,
    });
  },
  /**
   * Create a project.
   */
  createOne(name) {
    return raw.post(routes.projects.all(), {
      name: name,
    });
  },
  /**
   * Update a project.
   */
  updateOne(projectUid, project) {
    return raw.patch(routes.projects.one(projectUid), project);
  },
};
